module.exports = __webpack_public_path__ + "static/img/wenzi.5c43abf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/wenzi.png
// module id = Aouo
// module chunks = 1